import React from 'react';
import { DeviceIconProps, getSizeInPixels } from '../types';

/**
 * Fan Icon Style 01 - Mode Fan (Material Symbol)
 * - isOn = true: 青色實心風扇 + 旋轉動畫 (FILL: 1)
 * - isOn = false: 灰色空心風扇 (FILL: 0)
 * 
 * @see https://fonts.google.com/icons?selected=Material+Symbols+Outlined:mode_fan
 */
export const Style01_Fan: React.FC<DeviceIconProps> = ({ 
  isOn = false, 
  size = 'small',
  className = '',
  animated = true,
}) => {
  const pixelSize = getSizeInPixels(size);
  const colorClass = isOn ? 'text-cyan-500' : 'text-slate-400';
  const animationClass = isOn && animated ? 'fan-spin-medium' : '';

  return (
    <span 
      className={`material-symbols-outlined ${colorClass} ${animationClass} ${className}`}
      style={{ 
        fontSize: `${pixelSize}px`,
        fontVariationSettings: `'FILL' ${isOn ? 1 : 0}, 'wght' 400, 'GRAD' 0, 'opsz' 24`
      }}
    >
      mode_fan
    </span>
  );
};

export default Style01_Fan;
